// Vendors
import React, { createContext, useContext, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Enumerations
import { KycStatesEnumeration } from '../enumerations/kyc-states.enumeration';
import { KycMethodsEnumeration } from '../enumerations/kyc-methods.enumeration';
// Handlers
import { KycHandlers } from '../handlers/kyc.handlers';
// Hooks
import { useAppContextConsumerHook } from 'contexts/app.context';
// Types
import { KycContextType } from './types/kyc.context.type';
// Utils
import { getKycStateFromCurrentState } from './utils/kyc.context.utils';

const KycContext = createContext<KycContextType>({} as KycContextType);

const KycContextProvider = ({ children }: { children: React.ReactElement }): React.ReactElement => {
  const { showBoundary: setError } = useErrorBoundary();

  const { currentState } = useAppContextConsumerHook();

  const [kycState, setKycState] = useState<KycStatesEnumeration>(
    getKycStateFromCurrentState(currentState)
  );
  const [selectedMethod, setSelectedMethod] = useState<KycMethodsEnumeration>(
    '' as KycMethodsEnumeration
  );
  const [kycIdentificationId, setKycIdentificationId] = useState('');
  const [kycIframeUrl, setKycIframeUrl] = useState('');

  const { handleUpdateKycHeaderBackClick } = KycHandlers({
    setError,
    setKycState,
  });

  return (
    <KycContext.Provider
      value={{
        handleUpdateKycHeaderBackClick,
        kycIdentificationId,
        kycIframeUrl,
        kycState,
        selectedMethod,
        setKycIdentificationId,
        setKycIframeUrl,
        setKycState,
        setSelectedMethod,
      }}
    >
      {children}
    </KycContext.Provider>
  );
};

const useKycContextConsumerHook = (): KycContextType => useContext(KycContext);

/* eslint-disable */
const KycContextConsumerHOC =
  (Component: React.FunctionComponent<any>): React.FunctionComponent<any> =>
  (props: any): React.ReactElement<React.Provider<any>> =>
    (
      <KycContextProvider>
        <Component {...props} />
      </KycContextProvider>
    );

export { useKycContextConsumerHook, KycContextConsumerHOC, KycContextProvider };
